import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { ref, onMounted } from '@nuxtjs/composition-api'
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'


export default /*#__PURE__*/_defineComponent({
  __name: 'SharedButton',
  props: {
  isFullSize: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  },
  restName: {
    type: String as PropType<string>,
    required: false,
    default: ''
  }
},
  setup(__props) {

const props = __props



const iOS = ref<boolean | null>(null)

onMounted(() => {
  iOS.value = navigator.appVersion.includes('Mac OS')
})

const shareLink = async () => {
  const locUrl = window.location.href
  const shareData = {
    title: 'Tapper',
    text: `Оплати, пожалуйста, мой счет в ресторане ${props.restName}`,
    url: locUrl
  }
  try {
    await navigator.share(shareData)
    amplitudeLogEvent(amplitudeEvents.SHARE_BILL)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err)
  }
}


return { __sfc: true,props, iOS, shareLink }
}

})